import React from "react";
import {
  Modal,
  InlineLoading,
  InlineNotification,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  Link                    
} from "@carbon/react";

export default function TransactionModal({
  isTransactionModalOpen,
  setIsTransactionModalOpen,
  loadingTransactions,
  apiError,
  transactionRows,
  propertyInfo 
  //formatDate
}) {


  // ✅ Safe date formatter
  const formatDateTime = (value) => {
    if (!value) return "-";
    const date = new Date(value);

    // Handle invalid date (e.g. if API returns "11/9/2026, 3:44:20 am" or a bad string)
    if (isNaN(date.getTime())) {
      return String(value);
    }

    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  return (
    <Modal
      open={isTransactionModalOpen}
      modalHeading="Transaction Details"
      primaryButtonText="Close"
      secondaryButtonText=""
      onRequestClose={() => setIsTransactionModalOpen(false)}
      onRequestSubmit={() => setIsTransactionModalOpen(false)}
      size="lg"
    >
      {propertyInfo && (
        <div
          style={{
            marginBottom: "1rem",
            padding: "1rem",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            background: "#f9f9f9"
          }}
        >
          <div style={{ fontWeight: "600", marginBottom: "6px" }}>
            Property Summary
          </div>

          <div style={{ fontSize: "14px", color: "#525252" }}>
            <div><strong>Title:</strong> {propertyInfo.title || "-"}</div>
            <div><strong>Property ID:</strong> {propertyInfo.sequenceID}</div>
            <div><strong>Created By:</strong> {propertyInfo.createdBy || "-"}</div>
        
          </div>
        </div>
      )}

      {loadingTransactions ? (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <InlineLoading description="Loading transaction details..." />
        </div>
      ) : apiError ? (
        <div style={{ margin: "1rem" }}>
          <InlineNotification
            kind="error"
            title="Error"
            subtitle={apiError}
            lowContrast
          />
        </div>
      ) : transactionRows.length === 0 ? (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          No transactions found for this property
        </div>
      ) : (
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader>Transaction ID</TableHeader>
              <TableHeader>User</TableHeader>
              <TableHeader>Plan Name</TableHeader>
              <TableHeader>Type</TableHeader>
              <TableHeader>GST %</TableHeader>
              <TableHeader>Amount</TableHeader>
              <TableHeader>Method</TableHeader>
              <TableHeader>Gateway</TableHeader>
              <TableHeader>Gateway Txn ID</TableHeader>   {/* NEW */}
              <TableHeader>Invoice No.</TableHeader>      {/* NEW */}
              <TableHeader>Invoice</TableHeader> 
              <TableHeader>Status</TableHeader>
              <TableHeader>Date</TableHeader>
            </TableRow>
          </TableHead>

          <TableBody>
            {transactionRows.map((t) => (
              <TableRow key={t.id}>
                <TableCell>{t.transactionId}</TableCell>
                <TableCell>{t.name}</TableCell>
                <TableCell>
  {t.planName
    || t.plan
    || t.amountBreakup?.planName
    || t.AMOUNT_BREAKUP?.planName
    || "-"}
</TableCell>
                <TableCell>{t.transactionType}</TableCell>
                <TableCell>{t.gstPercentage}</TableCell>
                <TableCell>{t.amount}</TableCell>
                <TableCell>{t.paymentMethod}</TableCell>
                <TableCell>{t.paymentGateway}</TableCell>

                
                {/* NEW CELLS */}
                <TableCell>{t.gatewayTxnId || "-"}</TableCell>
                <TableCell>{t.invoiceNumber || "-"}</TableCell>
                <TableCell>
                  {t.invoicePdfPath ? (
                    <Link
                      href={t.invoicePdfPath}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </Link>
                  ) : (
                    "-"
                  )}
                </TableCell>

                <TableCell>{t.status}</TableCell>
                <TableCell>{formatDateTime(t.createdAt)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Modal>
  );
}